import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from "./router"
import './plugins/antd.js';
import './plugins/utils.js';
import './api/request'
import { message } from 'ant-design-vue';
import './plugins/userInfoTool.js'
import moment from 'moment';
Vue.config.productionTip = false
Vue.prototype.$message = message;

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
